import { render, staticRenderFns } from "./NormalEditor.vue?vue&type=template&id=d850bb48&scoped=true&"
import script from "./NormalEditor.vue?vue&type=script&lang=js&"
export * from "./NormalEditor.vue?vue&type=script&lang=js&"
import style0 from "./NormalEditor.vue?vue&type=style&index=0&id=d850bb48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d850bb48",
  null
  
)

export default component.exports